import { Typography } from "@mui/material";

/** Common style element for sub headings */
export function SubTitle({ children, ...restProps }) {
  return (
    <Typography variant="subtitle1" {...restProps}>
      {children}
    </Typography>
  );
}
